import React from "react";
import "./Topbar.css";
// Importing necessary icons
import { 
    FaEnvelope, 
    FaBell, 
    FaList, 
    FaAngleDown,
    FaBars 
} from "react-icons/fa";

const Topbar = ({ isSidebarVisible, toggleSidebar }) => {
  return (
    // 'header-container' includes the thin blue bar and the white content bar
    <div className="header-container">
      
      {/* Topmost Blue Bar */}
      <div className="blue-bar"></div>

      {/* Main Topbar Content */}
      <div className="topbar-content">
        
        {/* Left Section - Hamburger Menu for Mobile */}
        <div className="menu-toggle-topbar" onClick={toggleSidebar}>
          <FaBars />
        </div>

        {/* Center Search Bar Area */}
        <div className="search-area">
          <input type="text" placeholder="Search..." />
        </div>

        {/* Right Icons and Profile */}
        <div className="topbar-right">

          {/* Email Icon */}
          <div className="icon-box">
            <FaEnvelope />
            <span className="badge green-badge">1</span>
          </div>

          {/* Notification Icon with Badge '1' (Green in image) */}
          <div className="icon-box">
            <FaBell />
            <span className="badge red-badge">1</span>
          </div>

          {/* Other List Icon with Badge (Purple in image) */}
          <div className="icon-box">
            <FaList />
            <span className="badge purple-badge">1</span>
          </div>

          {/* Profile Section */}
          <div className="profile">
            <img 
              src="https://i.pravatar.cc/40?img=1" // Placeholder image for consistency
              alt="Wikolia" 
              className="profile-img"
            />
            <div className="profile-info">
              <h4 className="profile-name">Wikolia</h4>
              <span className="profile-role">Administrator</span>
            </div>
            <FaAngleDown className="profile-dropdown-icon" />
          </div>

        </div>
      </div>
    </div>
  );
};

export default Topbar;